var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import classNames from 'clsx';
import format from 'date-fns/format';
import { enGB } from 'date-fns/locale';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import { getDateFnsLocale } from '../../util-components/datetime';
import Button from '../button';
import ButtonGroup from '../button-group';
import Icon from '../icon';
import Label from '../label';
import MultilineDateRangePicker from '../multiline-daterange-picker';
import MultilineTimeRangePicker from '../multiline-timerange-picker';
import Popover from '../popover';
import WeekdayPicker from '../weekday-picker';
import { StyledContent, StyledPopoverSchedule } from './style';
var MAXIMUM_CALENDAR_HEIGHT = 330;
export var ScheduleActions;
(function (ScheduleActions) {
    ScheduleActions["ExclusiveToggled"] = "exclusive_toggled";
    ScheduleActions["FullScreenToggled"] = "full_screen_toggled";
    ScheduleActions["SpecificDateToggled"] = "specific_date_toggled";
    ScheduleActions["DayOfWeekChanged"] = "day_of_week_changed";
    ScheduleActions["DateChanged"] = "date_changed";
    ScheduleActions["TimeChanged"] = "time_changed";
})(ScheduleActions || (ScheduleActions = {}));
export var FlipWay;
(function (FlipWay) {
    FlipWay["TOP"] = "top";
    FlipWay["BOTTOM"] = "bottom";
})(FlipWay || (FlipWay = {}));
var SchedulePicker = /** @class */ (function (_super) {
    __extends(SchedulePicker, _super);
    function SchedulePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimension = function () {
            _this.setState({
                height: window.innerHeight,
            });
        };
        _this.toggleExclusive = function (event, data) {
            _this.setState({ isSetPriority: !_this.state.isSetPriority });
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.ExclusiveToggled, { checked: !_this.state.isSetPriority });
            }
        };
        _this.toggleFullscreen = function (event, data) {
            _this.setState({ isSetFullScreen: !_this.state.isSetFullScreen });
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.FullScreenToggled, { checked: !_this.state.isSetFullScreen });
            }
        };
        _this.handleTimeOnChange = function (data, conflictTimeList) {
            if (_this.props.callback) {
                _this.setState({
                    conflictTimeList: conflictTimeList,
                });
                _this.props.callback(ScheduleActions.TimeChanged, { time: data });
            }
        };
        _this.handleDateOnChange = function (data, conflictDateList) {
            if (_this.props.callback) {
                if (data.length > 0 && _this.state.isSpecificDateActive) {
                    _this.setState({
                        conflictDateList: conflictDateList,
                        isSpecificDateEnabled: true,
                    });
                    _this.props.callback(ScheduleActions.DateChanged, { date: data, specific_date: true });
                }
                else {
                    _this.props.callback(ScheduleActions.DateChanged, { date: data, specific_date: false });
                }
            }
        };
        _this.handleWeekdayPickerChanged = function (weekdayItems) { return __awaiter(_this, void 0, void 0, function () {
            var numEnabledDays;
            return __generator(this, function (_a) {
                numEnabledDays = 0;
                forEach(weekdayItems, function (value) {
                    if (value) {
                        numEnabledDays++;
                    }
                });
                if (numEnabledDays > 0) {
                    // callback, if weekdays have at least one one day
                    if (this.props.callback) {
                        this.props.callback(ScheduleActions.DayOfWeekChanged, { day_of_week: weekdayItems });
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.handlePopoverClick = function () {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { isSetScheduleOpen: !prevState.isSetScheduleOpen, isPopoverOpen: false })); });
        };
        _this.handleMouseEnter = function () {
            if (!_this.state.isSetScheduleOpen) {
                _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { isPopoverOpen: true })); });
            }
        };
        _this.buildDayOfWeekLabel = function (dayOfWeek) {
            var dayOfWeekLabel;
            if (Object.values(dayOfWeek).every(function (item) { return item === true; })) {
                dayOfWeekLabel = React.createElement(Label, { size: "mini", className: "everyday", active: true }, "EVERYDAY");
            }
            else {
                dayOfWeekLabel = React.createElement(React.Fragment, null,
                    React.createElement(Label, { size: "mini", active: dayOfWeek.mon }, "M"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.tue }, "T"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.wed }, "W"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.thu }, "T"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.fri }, "F"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.sat }, "S"),
                    React.createElement(Label, { size: "mini", active: dayOfWeek.sun }, "S"));
            }
            return dayOfWeekLabel;
        };
        _this.onOpen = function () {
            if (!_this.props.disabled) {
                _this.setState({ isSetScheduleOpen: true, isPopoverOpen: false });
            }
        };
        _this.getFlipDirection = function (_a) {
            var elementHeight = _a.elementHeight, elementTop = _a.elementTop;
            var elementRemainingHeight = _this.state.height - (elementHeight + elementTop);
            if (elementRemainingHeight < MAXIMUM_CALENDAR_HEIGHT) {
                return FlipWay.TOP;
            }
            return FlipWay.BOTTOM;
        };
        _this.handleWeeklyClick = function () {
            _this.setState({
                isSpecificDateActive: false,
                isSpecificDateEnabled: false,
            });
            if (_this.props.callback) {
                _this.props.callback(ScheduleActions.SpecificDateToggled, { specific_date: false });
            }
        };
        _this.handleSpecificDateClick = function () {
            _this.setState({
                isSpecificDateActive: true,
                isSpecificDateEnabled: !isEmpty(_this.props.date),
            });
            if (!isEmpty(_this.props.date) && _this.props.callback) {
                _this.props.callback(ScheduleActions.SpecificDateToggled, { specific_date: true });
            }
        };
        _this.isEverydaySelected = function () { return Object.values(_this.props.dayOfWeek).every(function (item) { return item === true; }); };
        _this.handleOutsideClick = function () {
            if (isEmpty(_this.props.date)) {
                _this.setState({
                    isSpecificDateActive: false,
                });
            }
            else {
                _this.setState({
                    isSpecificDateEnabled: true,
                });
            }
            _this.setState({
                isSetScheduleOpen: false,
            });
        };
        _this.state = {
            isSetScheduleOpen: false,
            isPopoverOpen: false,
            isSetPriority: props.isExclusiveEnabled || false,
            isSetFullScreen: props.isFullScreenEnabled || false,
            isSpecificDateEnabled: props.isSpecificDateEnabled && !isEmpty(_this.props.date),
            isSpecificDateActive: props.isSpecificDateEnabled && !isEmpty(_this.props.date),
            height: window.innerHeight,
        };
        window.addEventListener('resize', _this.updateDimension);
        return _this;
    }
    SchedulePicker.prototype.componentDidMount = function () {
        this.updateDimension();
    };
    SchedulePicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b;
        if (prevState.isSpecificDateEnabled !== this.props.isSpecificDateEnabled) {
            this.setState({
                isSpecificDateEnabled: (_a = this.props.isSpecificDateEnabled) !== null && _a !== void 0 ? _a : false,
                isSpecificDateActive: (_b = this.props.isSpecificDateEnabled) !== null && _b !== void 0 ? _b : false,
            });
        }
    };
    SchedulePicker.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateDimension);
    };
    SchedulePicker.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var flipWay = FlipWay.BOTTOM;
        var popoverContentElement = document.getElementsByClassName('popup transition center');
        if ((_a = popoverContentElement.item(0)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) {
            var popoverContentHeight = popoverContentElement.item(0).getBoundingClientRect().height;
            var popoverContentTop = popoverContentElement.item(0).getBoundingClientRect().top;
            flipWay = this.getFlipDirection({ elementHeight: popoverContentHeight, elementTop: popoverContentTop });
        }
        var popoverContent = (React.createElement(OutsideClickHandler, { onOutsideClick: this.handleOutsideClick },
            React.createElement(StyledContent, null,
                React.createElement(ButtonGroup, { size: "mini", className: "schedule-tab" },
                    React.createElement(Button, { onClick: this.handleWeeklyClick, active: !this.state.isSpecificDateActive }, "Weekly"),
                    React.createElement(Button, { onClick: this.handleSpecificDateClick, active: this.state.isSpecificDateActive }, "Specific date only")),
                !this.state.isSpecificDateActive &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "schedule-day" },
                            React.createElement(WeekdayPicker, { disabled: this.props.disabled, items: this.props.dayOfWeek, callback: this.handleWeekdayPickerChanged })),
                        React.createElement("h4", null, "And")),
                React.createElement("div", { className: "schedule-date" },
                    React.createElement(MultilineDateRangePicker, { compact: true, disablePastDateSelection: true, flipWay: flipWay, disabled: this.isEverydaySelected() && !this.state.isSpecificDateActive, locale: (_b = this.props.locale) !== null && _b !== void 0 ? _b : navigator.language, values: (_c = this.props.date) !== null && _c !== void 0 ? _c : [], overlapIndexes: (_d = this.props.overlapList) === null || _d === void 0 ? void 0 : _d.date_indexes, onChange: this.handleDateOnChange })),
                React.createElement("h4", null, "Play time"),
                React.createElement("div", { className: "schedule-time" },
                    React.createElement(MultilineTimeRangePicker, { disabled: this.props.disabled, locale: (_e = this.props.locale) !== null && _e !== void 0 ? _e : navigator.language, values: (_f = this.props.time) !== null && _f !== void 0 ? _f : [], overlapIndexes: (_g = this.props.overlapList) === null || _g === void 0 ? void 0 : _g.time_indexes, onChange: this.handleTimeOnChange })),
                React.createElement("div", { className: "schedule-options" },
                    React.createElement("h4", null, "More Options"),
                    !this.props.disabled &&
                        React.createElement(Popover, { trigger: React.createElement(Button, { fullWidth: true, danger: this.state.isSetPriority, onClick: this.toggleExclusive },
                                React.createElement(Icon, { name: "star" }),
                                this.state.isSetPriority
                                    ? React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.priority", defaultMessage: "Priority" })
                                    : React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.set_as.priority", defaultMessage: "Set as Priority" })), on: "hover", content: React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.priority-message", defaultMessage: "Making this content a priority will let it override all other schedules and rules during the defined period." }), position: "bottom center", inverted: true }),
                    this.props.showFullscreenOption &&
                        React.createElement(Popover, { trigger: React.createElement(Button, { fullWidth: true, upload: this.state.isSetFullScreen, onClick: this.toggleFullscreen },
                                React.createElement(Icon, { name: "play-fullscreen" }),
                                React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.set_as.priority", defaultMessage: "Play in Full Screen" })), on: "hover", content: React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.fullscreen-message", defaultMessage: "Making this content Full Screen will make only this piece of content and zone visible and will hide the other zones until it has finished playing during the defined period." }), position: "bottom center", inverted: true })))));
        var dayOfWeekLabel = this.buildDayOfWeekLabel(this.props.dayOfWeek);
        var listTime;
        var listDate;
        var locale = getDateFnsLocale((_h = this.props.locale) !== null && _h !== void 0 ? _h : navigator.language);
        if (this.props.time && this.props.time.length > 0) {
            listTime = this.props.time.map(function (time, index) {
                var _a, _b, _c, _d;
                // Temp date for Safari support
                var timeStart = format(new Date('2000-01-01T' + ((_a = time.start) === null || _a === void 0 ? void 0 : _a.trim())), locale === enGB ? 'pp' : 'hpp', { locale: locale });
                var timeEnd = format(new Date('2000-01-01T' + ((_b = time.end) === null || _b === void 0 ? void 0 : _b.trim())), locale === enGB ? 'pp' : 'hpp', { locale: locale });
                // show end time as 24h on en-GB
                if (timeEnd === '00:00:00') {
                    timeEnd = '24:00:00';
                }
                var isOverlap = _this.props.overlapList !== undefined ? (_d = (_c = _this.props.overlapList) === null || _c === void 0 ? void 0 : _c.time_indexes) === null || _d === void 0 ? void 0 : _d.some(function (item) { return item === index; }) : false;
                return (React.createElement("h5", { key: "time-" + index },
                    timeStart,
                    " - ",
                    timeEnd,
                    isOverlap &&
                        React.createElement(Popover, { trigger: React.createElement(Icon, { name: "warning", className: "icon-warning" }), content: "Conflicts with another time", position: "top center", inverted: true })));
            });
        }
        else {
            listTime = React.createElement("h5", null, "All day");
        }
        if (this.props.date && this.props.date.length > 0) {
            listDate = this.props.date.map(function (date, index) {
                var _a, _b, _c, _d;
                if (date.start === undefined || date.end === undefined) {
                    return;
                }
                var dateStart = date.start && date.start.split('-');
                var dateEnd = date.end && date.end.split('-');
                var isOverlap = _this.props.overlapList !== undefined ? (_b = (_a = _this.props.overlapList) === null || _a === void 0 ? void 0 : _a.date_indexes) === null || _b === void 0 ? void 0 : _b.some(function (item) { return item === index; }) : false;
                var isSameDate = date.start === date.end;
                return (React.createElement("h5", { key: "date-" + index },
                    React.createElement(React.Fragment, null,
                        date.start &&
                            format(new Date(Number(dateStart[0]), Number(dateStart[1]) - 1, Number(dateStart[2])), 'P', { locale: getDateFnsLocale((_c = _this.props.locale) !== null && _c !== void 0 ? _c : navigator.language) }),
                        (date.end) ? (React.createElement(React.Fragment, null, !isSameDate &&
                            React.createElement(React.Fragment, null,
                                ' ',
                                "-",
                                ' ',
                                format(new Date(Number(dateEnd[0]), Number(dateEnd[1]) - 1, Number(dateEnd[2])), 'P', { locale: getDateFnsLocale((_d = _this.props.locale) !== null && _d !== void 0 ? _d : navigator.language) })))) : (React.createElement(React.Fragment, null,
                            ' ',
                            "-",
                            ' ',
                            "Indefinite"))),
                    isOverlap &&
                        React.createElement(Popover, { trigger: React.createElement(Icon, { name: "warning", className: "icon-warning" }), content: "Conflicts with another date", position: "top center", inverted: true })));
            });
        }
        return (React.createElement(Popover, { className: "with-title", style: { padding: 0 }, onClose: function () { return _this.setState({ isSetScheduleOpen: false }); }, onOpen: this.onOpen, position: "bottom center", on: "click", size: "huge", trigger: React.createElement(StyledPopoverSchedule, { onMouseEnter: this.handleMouseEnter, onMouseLeave: function () { return _this.setState({ isPopoverOpen: false }); }, active: this.state.isSetScheduleOpen, disabled: this.props.disabled, className: "schedule-text" },
                React.createElement("div", { className: "schedule-row" },
                    (this.props.isExclusiveEnabled || this.props.isFullScreenEnabled) &&
                        React.createElement("div", { className: classNames("priority-group", { "priority-group__priority": this.props.isExclusiveEnabled, "priority-group__fullscreen": this.props.isFullScreenEnabled }) },
                            this.props.isExclusiveEnabled &&
                                React.createElement(Label, { size: "mini", className: "priority" },
                                    React.createElement(Icon, { name: "star" }),
                                    " ",
                                    React.createElement("span", null, "Priority")),
                            this.props.isFullScreenEnabled &&
                                React.createElement(Label, { size: "mini", className: "full_screen" },
                                    React.createElement(Icon, { name: "play-fullscreen" }),
                                    " ",
                                    React.createElement("span", null, "Full Screen"))),
                    !this.state.isSpecificDateActive &&
                        React.createElement("div", { className: "label-group" }, dayOfWeekLabel)),
                (this.state.isSpecificDateActive && this.props.date && this.props.date.length === 0) &&
                    React.createElement("div", { className: "schedule-row" },
                        React.createElement("div", { className: "schedule-date" },
                            React.createElement(Icon, { name: "calendar" }),
                            React.createElement("div", null, "-"))),
                this.props.date && this.props.date.length > 0 &&
                    React.createElement("div", { className: "schedule-row" }, (this.state.isSpecificDateActive || (!this.isEverydaySelected() && !this.state.isSpecificDateActive)) &&
                        React.createElement("div", { className: "schedule-date" },
                            React.createElement(Icon, { name: "calendar" }),
                            React.createElement("div", null, listDate))),
                React.createElement("div", { className: "schedule-row" },
                    React.createElement("div", { className: "schedule-time" },
                        React.createElement(Icon, { name: "clock" }),
                        React.createElement("div", null, listTime)))), open: this.state.isSetScheduleOpen, content: popoverContent }));
    };
    return SchedulePicker;
}(React.Component));
export { SchedulePicker };
export default SchedulePicker;
//# sourceMappingURL=index.js.map